<template>
  <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="promos.isLoading">
    <el-row type="flex" justify="space-between" align="middle" class="mb-4">
      <p class="category-title ma-0">
        Promo & Voucher
        <el-button
          @click="$router.push('/promovoucher/create')"
          type="primary"
          icon="el-icon-plus"
          circle
          size="small"
          class="ml-3"
        ></el-button>

        <input
          style="display: none"
          type="file"
          placeholder="Please Input Payment Note"
          ref="fileInputCsv"
          accept="text/csv"
          @change="e => onFilePicked(e, 'picture')"
        />
        <el-button
          type="primary"
          size="small"
          @click="onPickFile('picture')"
          style="margin-left: 10px"
          :loading="loadingUploadCsv"
        >Bulk Upload Voucher</el-button>
        <!-- <el-upload
          list-type="text/csv"
          action="https://jsonplaceholder.typicode.com/posts/"
          :before-upload="beforeAvatarUpload"
          style="display: initial; margin-left: 10px">
          <el-button size="small" type="primary"> Bulk Upload Vouhcer </el-button>
        </el-upload> -->
      </p>

      <el-col :span="14">
        <el-row type="flex" justify="end">
          <el-select
            v-model="optionView"
            placeholder="Select"
            size="small"
            class="mr-2"
            @change="
            e => {
              toAnotherPage(page, e), settingTable(page, e);
            }
          "
            style="width: 100px"
          >
            <el-option
              v-for="item in optionsView"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-input
              size="small"
              v-model="form.search"
              placeholder="Search by title"
              style="width: 200px"
              class="mr-2"
              @keyup.enter.native="onSearch"
            ></el-input>
        </el-row>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-table empty-text="Tidak ada data" :data="promos.data" style="width: 100%">
        <el-table-column sortable prop="promoId" label="ID"></el-table-column>
        <el-table-column sortable prop="title" label="Title"></el-table-column>
        <el-table-column sortable prop="budget" label="Budget"></el-table-column>
        <el-table-column sortable prop="start_date" label="Start Date"></el-table-column>
        <el-table-column sortable prop="end_date" label="End Date"></el-table-column>
        <el-table-column sortable prop="promoType" label="Tipe Promo"></el-table-column>
        <el-table-column sortable prop="active" label="Status">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.active"
              placeholder="Select"
              @change="(e) => handleUpdate(e, scope.row)"
            >
              <el-option
                v-for="item in optionsActive"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="Edit Promo" placement="top">
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                circle
                @click="$router.push(`/promovoucher/edit/${scope.row.promoType}/${scope.row.promoId}`)"
              ></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" content="Delete Promo" placement="top">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
                @click="handleDelete(scope.$index, scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Duplicate Promo" placement="top">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-copy-document"
                circle
                @click="$router.push(`/promovoucher/duplicate/${scope.row.promoType}/${scope.row.promoId}`)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="end">
        <el-pagination
          layout="prev, pager, next"
          :total="promos.count"
          :current-page="parseInt(page)"
          @current-change="
            e => {
              toAnotherPage(e, optionView), settingTable(e, optionView);
            }
          "
          :page-size="parseInt(optionView)"
        ></el-pagination>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ApiService from "../../common/api.service";

export default {
  data() {
    return {
      value: false,
      optionsActive: [
        {
          value: true,
          label: "Active"
        },
        {
          value: false,
          label: "No Active"
        }
      ],
      dialog: false,
      id: null,
      form: {
        search: ""
      },
      optionsView: [
        {
          value: 25,
          label: "25"
        },
        {
          value: 50,
          label: "50"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      page: 1,
      loadingUploadCsv: false
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getPromos: "promo/GetPromos",
      deletePromo: "promo/DeletePromo",
      updateStatusPromo: "promo/UpdateStatusPromo"
    }),
    toAnotherPage(page, limit) {
      this.$router.push({
        path: "/promovoucher",
        query: { page: page, limit: limit }
      });
    },
    onSearch() {
      this.$router.replace({ path: "/promovoucher", query: { page: 1, limit: 25, search: this.form.search } });
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getPromos(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView
        }
      };
      this.getPromos(option);
    },
    showDialog(id) {
      (this.id = id), (this.dialog = true);
    },
    handleDelete(idx, row) {
      const payload = {
        promoId: row.promoId,
        promoType: row.promoType
      }
      this.$confirm(
        "This will permanently delete the data. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.deletePromo(payload);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          });
        });
    },
    handleUpdate(value, row) {
      const payload = {
        id: row.promoId,
        promoType: row.promoType,
        isActive: value
      }
      this.updateStatusPromo(payload)
    },
    beforeAvatarUpload(file) {
      const isCsv = file.type === 'text/csv';

      if (!isCsv) {
        this.$message.error('File must be CSV format!');
      }
      return isCsv;
    },
    onPickFile() {
      this.$refs.fileInputCsv.click();
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      //const fileReader = new FileReader();
      //const tempBase64 = await this.toBase64(files[0])
      /* const body = {
        base64: tempBase64.replace('data:text/csv;base64,', '')
      }; */
      ApiService.init("heroku");
      this.loadingUploadCsv = true;
      try {
        //const file = await ApiService.post("/v1/promo/voucher/bulk", body); // perlu disesuaikan dengan relative url yang di-deploy
        this.loadingUploadCsv = false;
        this.$message.success('Upload voucher berhasil');
        let option = {
          params: {
            page: 1,
            limit: 25,
            search: '',
          }
        };
        await this.getPromos(option);
      } catch (error) {
        this.loadingUploadCsv = false;
        this.$message.error('Upload voucher tidak berhasil');
      }
    },
    
  },
  computed: {
    ...mapState({
      promos: state => state.promo.promos
    })
  },
  created() {
    this.page = this.$router.history.current.query.page || 1;
    this.optionView = this.$router.history.current.query.limit || 25;
    this.form.search = this.$router.history.current.query.search || '';
    let option = {
      params: {
        page: this.page,
        limit: this.optionView,
        search: this.form.search,
      }
    };
    this.getPromos(option);
  }
};
</script>

<style>
.el-select-dropdown__item {
}
.promo-title {
  text-align: left;
  font-size: 1.5rem;
}
</style>
